import { useCallback } from 'react';
import { type ValidationErrors } from 'final-form';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as Types from '../types';
import { intoDate } from '../helpers';

export const useValidate = () => {
    const translate = useComponentTranslations();

    return useCallback(({ from, until }: Types.IDates): ValidationErrors => {
        if (!from || !until) {
            return;
        }

        if (intoDate(from) > intoDate(until)) {
            return {
                from: translate('filter.error.timePeriod'),
                until: translate('filter.error.timePeriod')
            };
        }
    }, [translate]);
};
